import _ from "lodash";
import React from "react";
import styled from "styled-components";

import PrintColorRadio from "./shared/printColorRadio";
import { Divider } from "antd";
import PaperMaterialSelect from "./shared/paperMaterialSelect";
import { StyledContainer } from "./coverSection";
import { StyledMainDivider } from "./finishingCheckbox";

function ContentSection(props) {
  const {
    control,
    setValue,
    errors,
    trigger,
    contentFields,
    getValues,
    reset,
    watch,
    setPaperModalVisible,
    setAddPaperGrammageFrom,
  } = props;

  return (
    <StyledContainer error={_.get(errors, "content")}>
      <StyledMainDivider>Content</StyledMainDivider>
      <PrintColorRadio
        name="content"
        control={control}
        setValue={setValue}
        errors={errors}
        trigger={trigger}
        fields={contentFields}
        getValues={getValues}
        reset={reset}
        watch={watch}
      />
      <PaperMaterialSelect
        name="content"
        control={control}
        setValue={setValue}
        errors={errors}
        trigger={trigger}
        watch={watch}
        setPaperModalVisible={setPaperModalVisible}
        setAddPaperGrammageFrom={setAddPaperGrammageFrom}
      />
    </StyledContainer>
  );
}

export default ContentSection;
